import React, { useState } from 'react';
import { ChevronDown, Check } from 'lucide-react';
import { motion, AnimatePresence } from 'framer-motion';
import { CTAButton } from './CTAButton';
export function KitContents() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  const tomos = [{
    title: 'TOMO 1 — PROBLEMÁTICAS AMBIENTALES RURALES',
    icon: '🌱',
    items: ['Suelo, agua, agroquímicos', 'Deforestación', 'Impacto ambiental real', 'Casos en Argentina', 'Análisis de causas'],
    highlight: 'Para enseñar la realidad del campo',
    color: '#52B788'
  }, {
    title: 'TOMO 2 — PRODUCCIÓN SUSTENTABLE',
    icon: '🌿',
    items: ['Agroecología', 'Prácticas responsables', 'Producción consciente', 'Comparación de sistemas', 'Recursos naturales'],
    highlight: 'Para enseñar producción moderna',
    color: '#40916C'
  }, {
    title: 'TOMO 3 — PROYECTOS AMBIENTALES',
    icon: '🌾',
    items: ['Huerta escolar', 'Compostaje', 'Reciclaje rural', 'Proyectos aplicados', 'Guías paso a paso'],
    highlight: 'Para llevar la teoría a la práctica',
    color: '#2D6A4F'
  }, {
    title: 'TOMO 4 — EDUCACIÓN AMBIENTAL APLICADA',
    icon: '🌎',
    items: ['Casos reales', 'Problemáticas locales', 'Análisis del entorno', 'Conexión con el alumno', 'Reflexión crítica'],
    highlight: 'Para conectar con el alumno',
    color: '#1B9AAA'
  }, {
    title: 'TOMO 5 — ACTIVIDADES Y TRABAJO DE CAMPO',
    icon: '🧭',
    items: ['Actividades listas', 'Observación del entorno', 'Guías prácticas', 'Fichas imprimibles', 'Salidas de campo'],
    highlight: 'Para clases dinámicas',
    color: '#6B8E23'
  }, {
    title: 'TOMO 6 — PLANIFICACIÓN Y EVALUACIÓN',
    icon: '📊',
    items: ['Planificación anual', 'Evaluaciones listas', 'Rúbricas', 'Secuencias didácticas', 'Instrumentos'],
    highlight: 'Para tener todo organizado',
    color: '#D4A843'
  }];
  return <section className="bg-[#0E1F19] py-4 md:py-5 px-3 border-b border-[#1F3D2B]" data-id="element-93">
      <div className="max-w-2xl mx-auto" data-id="element-94">
        <h2 className="text-xl md:text-2xl font-black text-[#74C69D] text-center mb-3 uppercase tracking-tighter leading-tight" data-id="element-95">
          📖 QUÉ RECIBÍS
        </h2>

        <div className="space-y-1.5 mb-3" data-id="element-96">
          {tomos.map((tomo, index) => {
          const isOpen = openIndex === index;
          return <div key={index} className="bg-[#071A14] border border-[#1F3D2B] rounded overflow-hidden" data-id="element-97">
                <button onClick={() => setOpenIndex(isOpen ? null : index)} className="w-full flex items-center justify-between p-2 text-left hover:bg-[#102A1F] transition-colors" data-id="element-98">
                  <span className="font-black text-sm md:text-base flex items-center gap-2 uppercase tracking-tight" style={{
                color: tomo.color
              }} data-id="element-99">
                    <span className="text-base" data-id="element-100">{tomo.icon}</span> {tomo.title}
                  </span>
                  <motion.div animate={{
                rotate: isOpen ? 180 : 0
              }} data-id="element-101">
                    <ChevronDown className="w-4 h-4 text-[#D4A843]" data-id="element-102" />
                  </motion.div>
                </button>
                <AnimatePresence data-id="element-103">
                  {isOpen && <motion.div initial={{
                height: 0,
                opacity: 0
              }} animate={{
                height: 'auto',
                opacity: 1
              }} exit={{
                height: 0,
                opacity: 0
              }} className="overflow-hidden" data-id="element-104">
                      <div className="px-3 pb-3 border-t border-[#1F3D2B] bg-[#071A14]" data-id="element-105">
                        <ul className="grid grid-cols-1 sm:grid-cols-2 gap-1.5 mt-2 mb-2" data-id="element-106">
                          {tomo.items.map((item, i) => <li key={i} className="flex items-start gap-1.5 text-[#FFFFFF] font-bold text-[10px] md:text-xs leading-tight" data-id="element-107">
                              <Check className="w-3.5 h-3.5 text-[#74C69D] flex-shrink-0" strokeWidth={4} data-id="element-108" />
                              <span data-id="element-109">{item}</span>
                            </li>)}
                        </ul>
                        <div className="bg-[#102A1F] border border-[#D4A843]/30 rounded p-1.5 text-center mt-1.5" data-id="element-110">
                          <p className="text-[#D4A843] font-black text-[10px] md:text-xs uppercase" data-id="element-111">
                            👉 {tomo.highlight}
                          </p>
                        </div>
                      </div>
                    </motion.div>}
                </AnimatePresence>
              </div>;
        })}
        </div>

        <div className="text-center bg-[#102A1F] border border-[#D4A843] rounded p-3 shadow-sm mb-3" data-id="element-112">
          <p className="text-sm md:text-base font-black text-[#FFFFFF] mb-1 uppercase leading-tight" data-id="element-113">
            Todo paso a paso, listo para aplicar
          </p>
          <p className="text-xs md:text-sm font-black text-[#74C69D] uppercase leading-tight" data-id="element-114">
            Entrás a cada clase con todo resuelto
          </p>
        </div>

        <div className="flex justify-center" data-id="element-115">
          <CTAButton className="text-sm py-2.5" data-id="element-116">
            QUIERO MIS CLASES RESUELTAS
          </CTAButton>
        </div>
      </div>
    </section>;
}